export const overlay = {
  namespaced: true,
  state: {
    show: ''
  },
  mutations: {
    show(state) {
      state.show = true;
    },
    hide(state) {
      state.show = false;
    }
  }
}
